const projectsData = [
  // Condominium Projects
  {
    id: 'seresta-01',
    title: 'Seresta, Bdr Sri Dmnsara',
    titleImage: '/images/Condominium/Seresta/webp/20240820_143920_result.webp',
    images: [
      '/images/Condominium/Seresta/webp/20240820_143209_result.webp',
      '/images/Condominium/Seresta/webp/20240731_133226_result.webp',
      '/images/Condominium/Seresta/webp/20240731_133710_result.webp',
      '/images/Condominium/Seresta/webp/20240731_134220_result.webp',
      
      
      '/images/Condominium/Seresta/webp/20240820_143053_result.webp',
      '/images/Condominium/Seresta/webp/20240820_143224_result.webp',
      '/images/Condominium/Seresta/webp/20240820_143457_result.webp',
      '/images/Condominium/Seresta/webp/20240820_143542_result.webp',
      
      '/images/Condominium/Seresta/webp/20240820_144205_result.webp',
      '/images/Condominium/Seresta/webp/20240820_143920_result.webp',
      '/images/Condominium/Seresta/webp/20240820_144036_result.webp',
      '/images/Condominium/Seresta/webp/20240820_153705_result.webp',
      '/images/Condominium/Seresta/webp/20240820_153928_result.webp',
      '/images/Condominium/Seresta/webp/20240820_154337_result.webp',
      '/images/Condominium/Seresta/webp/20240820_154412_result.webp',

    ],
  },
  {
    id: 'the-park-02',
    title: 'The Park Resident, Bangsar',
    titleImage: '/images/Condominium/MTZ/webp/Image38.webp',
    images: [
      '/images/Condominium/MTZ/webp/Image45.webp',
      '/images/Condominium/MTZ/webp/Image11.webp',
      '/images/Condominium/MTZ/webp/Image30.webp',
      '/images/Condominium/MTZ/webp/Image32.webp',
      '/images/Condominium/MTZ/webp/Image33.webp',
      '/images/Condominium/MTZ/webp/Image34.webp',
      '/images/Condominium/MTZ/webp/Image39.webp',
      '/images/Condominium/MTZ/webp/Image48.webp',
      '/images/Condominium/MTZ/webp/Image50.webp',

    ],
  },

  {
    id: 'altris-03',
    title: 'Altris Residence, Wangsa Maju',
    titleImage: '//',
    images: [
      '/images/',
      '/images/',
      '/images/',
      '/images/',
    ],
  },

  {
    id: 'the-pulse-04',
    title: 'The Pulse Residence, Puchong',
    titleImage: '/images/Condominium/The Pulse - Feilou/Image03.webp',
    images: [
      '/images/Condominium/The Pulse - Feilou/Image03.webp',
      '/images/Condominium/The Pulse - Feilou/Image05.webp',
      '/images/Condominium/The Pulse - Feilou/Image08.webp',
      '/images/Condominium/The Pulse - Feilou/Image01.webp',
      '/images/Condominium/The Pulse - Feilou/Image02.webp',
      '/images/Condominium/The Pulse - Feilou/Image04.webp',
    ],
  },


  // Semi-D Projects
  {
    id: 'glenmarie-semi-01',
    title: 'Semi-D Project, 01',
    titleImage: '/images/Landed/Glenmarie/HM/20230914_140521.jpg',
    images: [
      '/images/Landed/Glenmarie/HM/20230914_140521.jpg',
      '/images/Landed/Glenmarie/HM/placeholder-c2.jpg',
      '/images/Landed/Glenmarie/HM/placeholder-c3.jpg',
      '/images/Landed/Glenmarie/HM/placeholder-c4.jpg',
    ],
  },


  // Commercial Projects
  {
    id: 'danson-00',
    title: 'Warehouse, KD',
    titleImage: '/images/Commercial/Danson/Down webp/20240526_153954.webp',
    images: [
      '/images/Commercial/Danson/Down webp/Edited 20240526_151232.webp',
      '/images/Commercial/Danson/Down webp/Edited 20240526_151632.webp',
      '/images/Commercial/Danson/Down webp/Edited 20240526_152206.webp',
      '/images/Commercial/Danson/Down webp/Edited 20240526_152404.webp',
      '/images/Commercial/Danson/Down webp/Edited 20240526_153053.webp',
      '/images/Commercial/Danson/Down webp/Edited 20240526_153120.webp',
      '/images/Commercial/Danson/Down webp/Edited 20240526_153220.webp',
      '/images/Commercial/Danson/Down webp/Edited 20240526_153351.webp',

      '/images/Commercial/Danson/Up webp/Image02.webp',
      '/images/Commercial/Danson/Up webp/Image04.webp',
      '/images/Commercial/Danson/Up webp/Image07.webp',
      '/images/Commercial/Danson/Up webp/Image11.webp',
      '/images/Commercial/Danson/Up webp/Image12.webp',
      '/images/Commercial/Danson/Up webp/Image13.webp',
      '/images/Commercial/Danson/Up webp/Image19.webp',
      '/images/Commercial/Danson/Up webp/Image14.webp',
      '/images/Commercial/Danson/Up webp/Image15.webp',
      '/images/Commercial/Danson/Up webp/Image09.webp',
      '/images/Commercial/Danson/Up webp/Image21.webp',
      '/images/Commercial/Danson/Up webp/Image20.webp',
      '/images/Commercial/Danson/Up webp/Image22.webp',
    ],
  },

  {
    id: 'aracafe-01',
    title: 'Fiftyfourc, Ara Dmnsara',
    titleImage: '/images/Commercial/Ara Cafe/JPEG Web Use/7M2062562_result.webp',
    images: [
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M2062562_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206259_HDR2_result.webp',

      '/images/Commercial/Ara Cafe/JPEG Web Use/7M205945_HDR1.webp',

      '/images/Commercial/Ara Cafe/JPEG Web Use/7M205936_HDR1.webp',

      
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M205951_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M205966_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M205972_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M205993_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206002_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206005_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206023_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206034_21.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206044_HDR1.webp',

      '/images/Commercial/Ara Cafe/JPEG Web Use/7M2062771.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206235_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206062_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206137_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206071_HDR1.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206083_HDR1.webp',
/*2nd add*/
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206140_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206176_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206173_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206107_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206110_HDR2_result.webp',  
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206098_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206116_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206122_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206197_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206206_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206200_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206213_HDR2_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M2062232_result.webp',
      '/images/Commercial/Ara Cafe/JPEG Web Use/7M2062252_result.webp',

      '/images/Commercial/Ara Cafe/JPEG Web Use/7M206014_HDR1.webp',
      

    ],
  },


  {
    id: 'foxboro-02',
    title: 'Foxboro, Shah Alam',
    titleImage: '/images/Commercial/Foxboro/Image01.webp',
    images: [
      '/images/Commercial/Foxboro/Image01.webp',
      '/images/Commercial/Foxboro/Image07.webp',
      '/images/Commercial/Foxboro/Image08.webp',
      '/images/Commercial/Foxboro/Image03.webp',
      '/images/Commercial/Foxboro/Image04.webp',
      '/images/Commercial/Foxboro/Image19.webp',
      '/images/Commercial/Foxboro/Image05.webp',
      '/images/Commercial/Foxboro/Image11.webp',
      '/images/Commercial/Foxboro/Image15.webp',
      '/images/Commercial/Foxboro/Image16.webp',
      '/images/Commercial/Foxboro/Image13.webp',
      '/images/Commercial/Foxboro/Image09.webp',
      '/images/Commercial/Foxboro/Image14.webp',
      '/images/Commercial/Foxboro/Image18.webp',
      '/images/Commercial/Foxboro/Image10.webp',
      '/images/Commercial/Foxboro/Image20.webp',
      '/images/Commercial/Foxboro/Image17.webp',
      '/images/Commercial/Foxboro/Image02.webp',
      '/images/Commercial/Foxboro/Image12.webp',

    ],
  },


  // Landed Projects
  {
    id: 'ttdi-01',
    title: 'TTDI, KL',
    titleImage: '/images/Landed/TTDI/webp/Image01.webp',
    images: [
      '/images/Landed/TTDI/webp/Image01.webp',
      /*'/images/Landed/TTDI/webp/7M204461_result.webp',
      '/images/Landed/TTDI/webp/1_result.webp',*/
      '/images/Landed/TTDI/webp/4_result.webp',   
      '/images/Landed/TTDI/webp/2_result.webp',
      '/images/Landed/TTDI/webp/3_result.webp',
      '/images/Landed/TTDI/webp/5_result.webp',  
      '/images/Landed/TTDI/webp/Image03.webp',
      '/images/Landed/TTDI/webp/Image02.webp',
      '/images/Landed/TTDI/webp/20250117_204629_result.webp',
      '/images/Landed/TTDI/webp/20250117_205304_result.webp',
      
      '/images/Landed/TTDI/webp/20250117_205927_result.webp',
      '/images/Landed/TTDI/webp/20250117_205634_result.webp',
      '/images/Landed/TTDI/webp/20250117_205652_result.webp',
    ],
  },

  {
    id: 'maluri-02',
    title: 'Maluri, Cheras',
    titleImage: '/images/Landed/Eepei/webp/20240913_115352_result.webp',
    images: [
      '/images/Landed/Eepei/webp/20240913_115352_result.webp',
      '/images/Landed/Eepei/webp/20240913_115342_result.webp',
      '/images/Landed/Eepei/webp/20240913_115447_result.webp',

      '/images/Landed/Eepei/webp/20240913_115308_result.webp',
      '/images/Landed/Eepei/webp/1.2.webp',


      '/images/Landed/Eepei/webp/20240913_115500_result.webp',
      '/images/Landed/Eepei/webp/20240913_120059_result.webp',
      '/images/Landed/Eepei/webp/20240913_115637_result.webp',
      '/images/Landed/Eepei/webp/20240913_115649_result.webp',
      '/images/Landed/Eepei/webp/20240913_115800_result.webp',
      '/images/Landed/Eepei/webp/20240913_115858_result.webp',
      '/images/Landed/Eepei/webp/20240913_120106_result.webp',
      '/images/Landed/Eepei/webp/20240913_120043_result.webp',
    ],
  },


  {
  id: 'glenmarie-00',
  title: 'Glenmarie, Shah Alam',
  titleImage: '/images/Landed/Glenmarie/webp/Kit/20240110_143021_result.webp',
  categories: [
    {
      name: 'Kitchen',
      images: [
        '/images/Landed/Glenmarie/webp/Kit/20240110_143021_result.webp',
        '/images/Landed/Glenmarie/webp/Kit/20240110_142943_result.webp',
        '/images/Landed/Glenmarie/webp/Kit/20240110_142927_result.webp',
        '/images/Landed/Glenmarie/webp/Kit/20240110_143113_result.webp',
        '/images/Landed/Glenmarie/webp/Kit/20240110_143153_result.webp',

        '/images/Landed/Glenmarie/webp/Kit/20240110_150018_result.webp',
        '/images/Landed/Glenmarie/webp/Kit/20240110_150043_result.webp',
        '/images/Landed/Glenmarie/webp/Kit/20240110_152037_result.webp',
        '/images/Landed/Glenmarie/webp/Kit/20240110_152137_result.webp',

        
      ],
    },
    {
      name: 'Master Bedroom',
      images: [
        '/images/Landed/Glenmarie/webp/Master/20231101_154940_result.webp',

        '/images/Landed/Glenmarie/webp/Master/20231101_155101_result.webp',
        '/images/Landed/Glenmarie/webp/Master/20230914_163122_result.webp',
        '/images/Landed/Glenmarie/webp/Master/20231101_155620_result.webp',
        '/images/Landed/Glenmarie/webp/Master/20231101_161101_result.webp',
        '/images/Landed/Glenmarie/webp/Master/20231101_160628_result.webp',
        
      ],
    },
    {
      name: 'Bedrooms',
      images: [
        '/images/Landed/Glenmarie/webp/Bedroom/20230914_140521_result.webp',
        '/images/Landed/Glenmarie/webp/Bedroom/20230914_140647 (1)_result.webp',
        '/images/Landed/Glenmarie/webp/Bedroom/20230914_140638_result.webp',
        '/images/Landed/Glenmarie/webp/Bedroom/20230914_140747_result.webp',

        '/images/Landed/Glenmarie/webp/Bedroom/20230731_143729_result.webp',
        '/images/Landed/Glenmarie/webp/Bedroom/20230731_143740_result.webp',
        '/images/Landed/Glenmarie/webp/Bedroom/20230731_143844_result.webp',
        '/images/Landed/Glenmarie/webp/Bedroom/20230731_143926_result.webp',
        '/images/Landed/Glenmarie/webp/Bedroom/20230731_144020_result.webp',

        
      ],
    },
    {
      name: 'Study Rooms',
      images: [

        '/images/Landed/Glenmarie/webp/Study/20230731_143418_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20230731_143451_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20230731_143614_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20230731_143451_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20231101_161729_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20231101_161800_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20231101_161935_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20230703_162108 (1)_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20230703_162151_result.webp',
        '/images/Landed/Glenmarie/webp/Study/20230703_162226_result.webp',
      ],
    },
    {
      name: 'Accessories',
      images: [
        '/images/Landed/Glenmarie/webp/Acs/20240110_143428_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_143507_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_143520_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_143543_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_143635_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_143729_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_150150_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_150301_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_150349_result.webp',
        '/images/Landed/Glenmarie/webp/Acs/20240110_150545_result.webp',
        
      ],
    },
  ],
},

  
];

export default projectsData;